/**
 * 견적 관련 API 훅
 * 견적서 조회 기능을 제공하는 커스텀 훅입니다.
 */

import { useCallback } from "react";
import { getQuotationAsync } from "src/api/contract/contract-api";
import { useApiOperation } from "src/api/hooks";

/**
 * 견적 관련 API 훅
 * 견적서 목록을 조회하는 기능을 제공합니다.
 */
const useEstimateApi = () => {
  /** 견적서 조회 API */
  const { executeAsync: getQuotation } = useApiOperation(getQuotationAsync);

  /**
   * 견적서 목록 조회
   * @param params - 조회 파라미터
   * @returns 견적서 목록 데이터
   */
  const getEstimateList = useCallback(
    async (params: any) => {
      return await getQuotation(params);
    },
    [getQuotation],
  );

  return { getEstimateList };
};

export default useEstimateApi;
